import { render } from "./GuestsPage.vue?vue&type=template&id=2a414742"
import script from "./GuestsPage.vue?vue&type=script&lang=js"
export * from "./GuestsPage.vue?vue&type=script&lang=js"

import "@/css/GuestsPage.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__